import { render, staticRenderFns } from "./PosInvoicesTax.vue?vue&type=template&id=95f34faa&scoped=true&"
import script from "./PosInvoicesTax.vue?vue&type=script&lang=js&"
export * from "./PosInvoicesTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f34faa",
  null
  
)

export default component.exports